module.exports = __webpack_public_path__ + "assets/img/button-top.91696228.png";